import { useRentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent } from '@zg-rentals/ts-rental-manager-api-client-react-query';

const useConvertSingleFamilyToRoomForRent = () =>
  useRentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent({
    meta: {
      context: {
        api: 'rentalManager',
        details: 'useRentalManagerUserPropertyConvertV2WebApiHandler_singleFamilyToRoomForRent',
      },
      invalidates: ['users-properties-convert-singleFamilyToRoomForRent'],
    },
  });

export { useConvertSingleFamilyToRoomForRent };
